<div class="fixed top-0 left-0 right-0 z-50">
  <div
    class="flex flex-row justify-between py-4 px-8 border border-neutral-border bg-neutral-50"
  >
    @if (loadingLogo()) {
      <p-skeleton
        width="221px"
        height="61px"
        class="bg-slate-300 rounded-md"
      ></p-skeleton>
    } @else {
      <img
        [src]="logoUrl() ?? '../../../../assets/images/brand/logo-nav.svg'"
        alt="declarabid-logo"
        class="w-[221px] h-[61px] object-contain"
      />
    }

    <div class="flex flex-row gap-[23px] items-center">
      @if (currentUserRole() === UserRole.admin) {
        <!-- <lib-global-button
          type="default"
          label="Sitio web público"
          i18n-label
          icon="pi pi-objects-column"
          [routerLink]="'/admin/public-website'"
        /> -->
        <lib-global-button
          type="default"
          label="Instituciones"
          i18n-label
          icon="pi pi-building"
          [routerLink]="'/admin/institutions'"
        />

        <lib-global-button
          type="default"
          label="Usuarios"
          i18n-label
          icon="pi pi-user"
          [routerLink]="['/' + routeUser + '/users']"
        />
        <lib-global-button
          type="default"
          label="Reportes"
          i18n-label
          icon="pi pi-chart-line"
          [routerLink]="'/admin/report'"
        />
        <lib-global-button
          type="default"
          label="Configuración del sistema"
          i18n-label
          icon="pi pi-cog"
          [routerLink]="'/admin/config-system'"
        />
      }

      @if (currentUserRole() !== UserRole.admin) {
        @for (link of items; track $index) {
          <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
        }
      }

      <div class="relative inline-flex">
        <lib-global-button
          type="neutral"
          icon="pi pi-bell"
          onKeyPress=""
          (click)="show($event)"
        />
        @if (hasUnread()) {
          <span
            class="absolute top-[-4px] right-[-4px] w-5 h-5 rounded-full bg-error-900 border-2 border-white pointer-events-none"
          ></span>
        }
      </div>

      <p-avatar
        class="h-12 flex items-center cursor-pointer"
        icon="pi pi-user"
        size="large"
        shape="circle"
        (click)="menu.toggle($event)"
        onkeypress=""
      ></p-avatar>
    </div>
  </div>
  @if (currentUserRole() === UserRole.admin) {
    <nav
      class="flex justify-between bg-neutral-100 h-[68px] px-8 py-4 shadow-md"
    >
      @if (currentUserRole() === UserRole.admin) {
        @for (link of items; track $index) {
          <lib-menu-item [text]="link.name" [routerRedirect]="link.route" />
        }
      }
    </nav>
  }
</div>

<p-menu #menu [popup]="true" [model]="options" appendTo="body"></p-menu>

<p-popover #op (onShow)="onShow()" (onHide)="onHide()" appendTo="body">
  <app-overlay-notifications />
</p-popover>
